import { DEFAULT_FONT_SIZE } from "./constants.js";
import { graphToExcalidraw } from "./graphToExcalidraw.js";
import { parseMermaid } from "./parseMermaid.js";
const parseMermaidToExcalidraw = async (definition, config) => {
    const mermaidConfig = config || {};
    const fontSize = parseInt(mermaidConfig.themeVariables?.fontSize ?? "") || DEFAULT_FONT_SIZE;
    const parsedMermaidData = await parseMermaid(definition, {
        ...mermaidConfig,
        themeVariables: {
            ...mermaidConfig.themeVariables,
        },
    });
    // Only font size supported for excalidraw elements
    const excalidrawElements = graphToExcalidraw(parsedMermaidData, {
        fontSize,
    });
    return excalidrawElements;
};
export { parseMermaidToExcalidraw };
//# sourceMappingURL=index.js.map